import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-powerbi-frame',
  templateUrl: './powerbi-frame.component.html',
  styleUrls: ['./powerbi-frame.component.less']
})
export class PowerbiFrameComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
